import React from 'react'

import { arrayOf, bool, shape, string } from 'prop-types'

import LazyAiSignInModal from 'Pods/LazyLoaded/AiSignInModal/LazyAiSignInModal'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CenteredTitle from './Components/CenteredTitle/CenteredTitle'
import CommunityGallery from './Components/CommunityGallery/CommunityGallery'
import CTABanner from './Components/CTABanner/CTABanner'
import FAQs from './Components/FAQs/FAQs'
import GoToTop from './Components/GoToTop/GoToTop'
import UpgradeHeader from './Components/UpgradeHeader/UpgradeHeader'
import useAuthModalTrigger from './Hooks/useAuthModalTrigger'

// This is a cacheable fast page, so per-user 3D Studio subscription state is not
// available at SSR time -- it is delivered client-side via window.pageConfig
// (built in has_fast_application_state_helpers.rb, flushed by /load-services.js).
// Sections read only the fields they need with usePageConfig (see UpgradeHeader),
// so this root stays a plain layout. Three non-user-specific values are threaded
// from SSR props (see react_props_ai_sub_landing): extractingCoreStyles, an
// SSR-render-time flag (false outside extraction) that lets per-user sections
// force-render during the critical-CSS extraction pass so their styles are
// captured; communityGalleryCategories, the shared search-aggregation chips; and
// subscriptionPaymentFormUrl, the absolute payment-form URL the CTA falls back to
// before per-user page config hydrates (and for signed-out visitors).
function AiSubLanding({
  extractingCoreStyles = false,
  communityGalleryCategories = EMPTY_ARRAY,
  subscriptionPaymentFormUrl = '',
}) {
  const { signInModalMode, closeSignInModal } = useAuthModalTrigger()

  return (
    <div className="ai-sub-landing">
      <UpgradeHeader
        extractingCoreStyles={extractingCoreStyles}
        subscriptionPaymentFormUrl={subscriptionPaymentFormUrl}
      />
      <CenteredTitle />
      <CommunityGallery
        categories={communityGalleryCategories}
        extractingCoreStyles={extractingCoreStyles}
      />
      <FAQs />
      <CTABanner subscriptionPaymentFormUrl={subscriptionPaymentFormUrl} />
      <GoToTop />
      {signInModalMode && (
        <LazyAiSignInModal mode={signInModalMode} onClose={closeSignInModal} />
      )}
    </div>
  )
}

AiSubLanding.propTypes = {
  extractingCoreStyles: bool,
  communityGalleryCategories: arrayOf(shape({
    name: string.isRequired,
    value: string.isRequired,
  })),
  subscriptionPaymentFormUrl: string,
}

export default AiSubLanding
